import { isClass } from '../isClass';

export const createLazySingleton = <T>(
    Factory: (new () => T) | (() => T)
): (() => T) => {
    let singleton: T;

    return () => {
        if (!singleton) {
            if (isClass(Factory)) {
                singleton = new (Factory as new () => T)();
            } else {
                singleton = (Factory as () => T)();
            }
        }

        return singleton;
    };
};
